var c = Object.defineProperty;
var n = (s, e, r) => e in s ? c(s, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : s[e] = r;
var o = (s, e, r) => n(s, typeof e != "symbol" ? e + "" : e, r);
class i {
  /**
   * Constructs a CookieConsentsDTO with the given partial consents.
   */
  constructor(e) {
    /**
     * Consent for proposals-related cookies.
     */
    o(this, "proposals");
    /**
     * Consent for search-related cookies.
     */
    o(this, "search");
    /**
     * Consent for marketing-related cookies.
     */
    o(this, "marketing");
    /**
     * Consent for experience-related cookies.
     */
    o(this, "experience");
    Object.assign(this, {
      proposals: e.proposals ?? !1,
      search: e.search ?? !1,
      marketing: e.marketing ?? !1,
      experience: e.experience ?? !1
    });
  }
}
export {
  i as CookieConsentsDTO
};
